import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete"; 
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload"
import Select from "react-select";
import swal from "sweetalert";
import { Progress } from "reactstrap"; 
const SecurityIncident = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [inputsPersonInvolved, setInputsPersonInvolved] = useState({});
    const [inputsActionTaken, setInputsActionTaken] = useState({});
    const [documents, setDocuments] = useState({});
    const [view, setView] = useState(false);    
    const [viewActiontaken, setViewActiontaken] = useState(false);   
    
    const [viewDocuments, setViewDocuments] = useState(false); 
    const [viewPersonInvloved, setViewPersonInvloved] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Security Incidents");
    const [incidentTypes,setIncidentTypes] = useState([]);
    const [allActiontaken,setAllActionTaken] = useState([]);
    
    const [allDocuments,setAllDocuments] = useState([]);
    const [allpersonsInvolved,setAllpersonsInvolved] = useState([]);
    const [incidentLikelyhood,setIncidentLikelyhood] = useState([]);
    const [severity, setSeverity] = useState([]);
    const [documentTypes, setdocumentTypes] = useState([]);
    const [counties, setCounties] = useState([]);
    const [subcounties, setSubcounties] = useState([]);
    const [activeTab, setActiveTab] = useState('incident');
    const [RowData, setRowData] = useState([]);

    const [selectedFile, setselectedFile] = useState("");
    const [loaded, setloaded] = useState("");
    const [message, setmessage] = useState("");
    const maxSelectFile = (event) => {
        let files = event.target.files; // create file object
        if (files.length > 1) {
          const msg = "Only One file can be uploaded at a time";
          event.target.value = null;
          setmessage(msg);
    
          return false;
        }
        return true;
      };
    const onChangeHandler = (event) => {
        //for multiple files
        var files = event.target.files;
        if (maxSelectFile(event)) {
          setselectedFile(files);
          setloaded(0);
        }
      };
      const onClickHandler = (event) => {
        event.preventDefault();
        if (selectedFile) {
          const data = new FormData();
          for (var x = 0; x < selectedFile.length; x++) {
            data.append("file", selectedFile[x]);
          }
          Upload.post("/api/upload/files", data, {
            // receive two parameter endpoint url ,form data
            onUploadProgress: (ProgressEvent) => {
              setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
            },
          })
            .then((res) => {
              if (res.status == "200" && res.data.resultCode=="00") {
                setmessage("Uploaded successfully");
                setDocuments((documents) => ({ ...documents, path: res.data.data }));
              }else{
                setmessage("upload fail");
              }
            })
            .catch((err) => {
              setmessage("upload fail");
            });
        } else {
          setmessage("Select a file to upload");
        }
      };

    const url = "api/securityIncidents"; 
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
      };
      const handleSelectPersonInvolvedChange = (UserGroup, actionMeta) => {
        setInputsPersonInvolved((inputsPersonInvolved) => ({ ...inputsPersonInvolved, [actionMeta.name]: UserGroup.value }));
      }; 
      const handleSelectDocumentsChange = (UserGroup, actionMeta) => {
        setDocuments((documents) => ({ ...documents, [actionMeta.name]: UserGroup.value }));
      }; 
      const fetchPersonsInvolved = async (incidentId) => {
        try {
            Api.get("api/personsInvolved/getByIncidentId?incidentId="+incidentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllpersonsInvolved(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchDocuments = async (incidentId) => {
        try {
            Api.get("api/documents/getByIncidentId?incidentId="+incidentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllDocuments(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            
        }
    };
    const fetchActiontaken = async (incidentId) => {
        try {
            Api.get("api/actionTaken/getByIncidentId?incidentId="+incidentId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllActionTaken(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchIncidentTypes = async () => {
        try {
            Api.get("api/incidentTypes/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.incidentTypes.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setIncidentTypes((inputs) => [ ...inputs, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const policeCalledToSceneOptions=[
        {
            value: "Yes",
            label: "Yes",
        },
        {
            value: "No",
            label: "No",
        }   
    ]
    const fetchIncidentLikelyHood = async () => {
        try {
            Api.get("api/incidentLikelyHood/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.incidentLikelyHood.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setIncidentLikelyhood((inputs) => [ ...inputs, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };

    const fetchCounties = async () => {
        try {
            Api.get("api/counties/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.forEach((k) => {
                        let col = {
                            value: k.countyId,
                            label: k.name,
                        }; 
                        setCounties((counties) => [ ...counties, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching Counties:", error);
        }
    };
    const fetchSubCounties = async () => {
        setSubcounties([])
        try {
            Api.get("api/subCounties/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.forEach((k) => {
                        let col = {
                            value: k.subCountyId,
                            label: k.name,
                        };
                        setSubcounties((subcounties) => [ ...subcounties, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching Counties:", error);
        }
    };
    const fetchSeverity = async () => {
        try {
            Api.get("api/severityLevel/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.severityLevel.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setSeverity((inputs) => [ ...inputs, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchDocumentTypes = async () => {
        try {
            Api.get("api/docType/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.docType.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setdocumentTypes((documentTypes) => [ ...documentTypes, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const MoreActions = (props) => {
        return (
          <span>
            <a
              class="btn btn-secondary btn-sm dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              More Actions&nbsp;&nbsp;
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </a>
    
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleView(props.selecteditem, e)}
              >
                View
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleEdit(props.selecteditem, e)}
              >
                Edit
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => HandleDelete(props.selecteditem, e)}
              >
                Delete
              </a>
    
    
            </div>
          </span>
        );
      };
    const setIncidentsdata = async (data) => {       
        const rows = data?.securityIncidents || [];                 
                
                rows.forEach((k) => {
                    const Rowdata = { 
                        id:k.id,
                        incidentNo: k.incidentNo, 
                        timeOfIncident: k.timeOfIncident,
                        locationName: k.locationName,
                        nameOfOrganization: k.nameOfOrganization,
                        incidentTypeId: k.incidentTypeId,
                        severityLevel: k.severityLevel?.name,
                        policeCalledToScene: k.policeCalledToScene,
                        createdBy: k.createdBy, 
                        createdAt:k.createdAt,
                        dateOfIncident: formatDate(k.dateOfIncident), 
                        Actions: <MoreActions selecteditem={k} />,
                        countyId:k.countyId,
                        subCountyId:k.subCountyId,
                        severityId:k.severityId,
                        likelyHoodId:k.likelyHoodId,
                        incidentType:k.incidentType?.name, 
                        incidentLikelyHood:k.incidentLikelyHood?.name,
                        subCounty:k.subCounty?.name,
                        county:k.subCounty?.counties?.name
                    }; 
                    setRowData((inputs) => [ ...inputs, Rowdata ]);
                        
                });
            
    }
    const FetchAll = async () => { 
        setRowData([]);
        try {
            Api.get(url + "/getAll?page=0&size=1")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setIncidentsdata(data); 
                const totalPages = data.totalPages;   
                for (let i = 0; i < totalPages; i++) {  
                    let nextPage=parseFloat(i) + parseFloat(1) ;       
                    Api.get(url + "/getAll?page="+nextPage+"&size=1")
                    .then(function (response) {                        
                      if (response.status=== 200) {
                        const data =response.data;
                        setIncidentsdata(data); 
                      }
                    })
                    .catch(function (error) {
                    })
                    .then(function () {
                      // always executed
                    }) 
                }
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })

            

            
        } catch (error) {
            console.error("Error fetching securityIncidents:", error);
        }
    }; 
    useEffect(() => {
        FetchAll();   
        fetchIncidentTypes();    
        fetchSeverity();
        fetchDocumentTypes();
        fetchCounties();
        fetchSubCounties();
        fetchIncidentLikelyHood();
    }, []);

  

    const handleOpenModal = () => {
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    const handlePersonsInvolvedInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputsPersonInvolved((inputsPersonInvolved) => ({ ...inputsPersonInvolved, [name]: value }));
    };
    const handleActionTakenInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputsActionTaken((inputsActionTaken) => ({ ...inputsActionTaken, [name]: value }));
    };
    const handleDocumentsInputChange= (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setDocuments((documents) => ({ ...documents, [name]: value }));
    };
    const handleEdit = (k) => {
        setInputs(k);
        if (k.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const HandleDelete = (k) => {
        setInputs(k);
        if (k.id) {
            CallDeleteHook(k.id);
        } else {
            alert("Select a record to delete");
        }
    };
    const handleView = (k) => {
        setInputs(k);
        setInputsActionTaken((inputsActionTaken) => ({ ...inputsActionTaken, ["incidentId"]: k.id }));
        setInputsPersonInvolved((inputsPersonInvolved) => ({ ...inputsPersonInvolved, ["incidentId"]: k.id }));
        setDocuments((documents) => ({ ...documents,["incidentId"]: k.id }));
        if (k.id) {
            fetchPersonsInvolved(k.id);
            fetchDocuments(k.id);
            fetchActiontaken(k.id);
            setView(true);
            setViewPersonInvloved(true);
            setViewActiontaken(true)
            setViewDocuments(true)
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };
    const useSave = (url = ``, inputs = {},menu=``, config = {}) => {
        
        let data;
        let headers;
    
        if (inputs instanceof FormData) {
          data = inputs;
          headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
        } else {
          data = JSON.stringify(inputs);
          headers = { 'Content-Type': 'application/json', ...config.headers };
        }      
        Api.post(url, data, { headers })
          .then((response) => {
            if (response.data.resultCode === "00") {
              if(menu==="Incident"){
                  var result = JSON.parse(response.data.data); 
                  setInputs((inputs) => ({ ...inputs, ["id"]: result.id }));
                  setInputsActionTaken((inputsActionTaken) => ({ ...inputsActionTaken, ["incidentId"]: result.id }));
                  setInputsPersonInvolved((inputsPersonInvolved) => ({ ...inputsPersonInvolved, ["incidentId"]: result.id }));
                  setDocuments((documents) => ({ ...documents,["incidentId"]: result.id })); 
              }
             
              swal("", "saved", "success"); 
            } else {
              swal("", response.data.description, "error"); 
            }
          })
          .catch((error) => {
            swal("", "Failed", "error"); 
          });
      
    };
    const HandleSave = (inputs,url,menu) => {
        useSave(url+"/create", inputs,menu);
        setTimeout(function () {
            FetchAll();
        }, 4000);
    };

    const HandleUpdate = (inputs,url) => {
        useUpdate(url+"/update" , inputs);
        setTimeout(function () {
            FetchAll();
        }, 4000);
       
    };

    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate(inputs,url);
        } else {
            HandleSave(inputs,url,"Incident");
        }
    };
    const HandleSubmitDocuments = (event) => {
        event.preventDefault(); 
        
        if(!documents.incidentId || documents.incidentId === "undefined"){
            alert("Add or select security incident first")
            return;
        } 
        if (update) {
            HandleUpdate(documents,"api/documents");
        } else {
            HandleSave(documents,"api/documents","Document");
        }
        setTimeout(function () {
            fetchDocuments(inputs.id)
        }, 4000);
        
    };
    const HandleSubmitActionTaken = (event) => {

        event.preventDefault(); 
        if(!inputsActionTaken.incidentId || inputsActionTaken.incidentId == "undefined"){
            alert("Add or select security incident first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsActionTaken,"api/actionTaken");
        } else {
            HandleSave(inputsActionTaken,"api/actionTaken","ActionTaken");
        }
        setTimeout(function () {
            fetchPersonsInvolved(inputs.id)
        }, 4000);
        
    };
    
    const HandleSubmitPersonsInvloved = (event) => {

        event.preventDefault(); 
        if(!inputsPersonInvolved.incidentId || inputsPersonInvolved.incidentId == "undefined"){
            alert("Add or select security incident first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsPersonInvolved,"api/personsInvolved");
        } else {
            HandleSave(inputsPersonInvolved,"api/personsInvolved","Incident");
        }
        setTimeout(function () {
            fetchPersonsInvolved(inputs.id)
        }, 4000);
        
    };

    const CallDeleteHook = (id) => {
        useDelete(url + "/delete?id=" + id);
        setTimeout(function () {
            FetchAll();
        }, 4000);
        
    };



    const formatDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 16);
    };

    const ColumnData = [
        { label: "Incident No", field: "incidentNo", sort: "asc" },
        { label: "Date Of Incident", field: "dateOfIncident", sort: "asc" },
        { label: "Time Of Incident", field: "timeOfIncident", sort: "asc" },
        { label: "Location", field: "locationName", sort: "asc" },
        { label: "Organization", field: "nameOfOrganization", sort: "asc" },
        { label: "Type", field: "incidentType", sort: "asc" },
        { label: "severityLevel", field: "severityLevel", sort: "asc" },
        { label: "policeCalledToScene", field: "policeCalledToScene", sort: "asc" },
        { label: "Subcounty", field: "subCounty", sort: "asc" },
        {
            label: "Actions",
            field: "Actions",
            sort: "asc",
          }

    ];
   

   

    const ActionsBtn = () => {
        return (
            <div>
                {/* {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null} */}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Security Incidents</li>
            </ol>
            <h1 className="page-header mb-3">Security Incidents</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New Security Incident &nbsp;
                            </button>
                        ) : null}
                         
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="80%" height="90%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 font-weight-bold text-blue">
                                Security incident
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />
                                <div className="tab-content" id="myTabContent">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'incident' ? 'active' : ''}`} id="incident-tab" onClick={() => setActiveTab('incident')} role="tab" aria-selected={activeTab === 'incident'}>Security Incident</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'persons-involved' ? 'active' : ''}`} id="persons-involved-tab" onClick={() => setActiveTab('persons-involved')} role="tab" aria-selected={activeTab === 'persons-involved'}>Persons Involved</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'actions-taken' ? 'active' : ''}`} id="actions-taken-tab" onClick={() => setActiveTab('actions-taken')} role="tab" aria-selected={activeTab === 'actions-taken'}>Action taken</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Documents' ? 'active' : ''}`} id="Documents-tab" onClick={() => setActiveTab('Documents')} role="tab" aria-selected={activeTab === 'Documents'}>Documents</a>
                                            </li> 
                                </ul>
                                <div className={`tab-pane fade ${activeTab === 'incident' ? 'show active' : ''}`} id="mou-tab-pane" role="tabpanel" aria-labelledby="incident-tab">
                                <h3>Security incident details</h3>
                                   {view ? (
                                    <div>
                                            <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">incidentNo:</td>
                                                    <td>{inputs.incidentNo}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Date Of Incident:</td>
                                                    <td>{inputs.dateOfIncident}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Time Of Incident:</td>
                                                    <td>{inputs.timeOfIncident}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Description:</td>
                                                    <td>{inputs.description}</td>
                                                </tr>
                                                
                                                <tr>
                                                    <td className="font-weight-bold">Location Name:</td>
                                                    <td>{inputs.locationName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Police Called To Scene:</td>
                                                    <td>{inputs.policeCalledToScene}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">LikelyHood:</td>
                                                    <td>{inputs.incidentLikelyHood.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">County:</td>
                                                    <td>{inputs.subCounty.counties.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Subcounty:</td>
                                                    <td>{inputs.subCounty.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">severityLevel:</td>
                                                    <td>{inputs.severityLevel.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Status:</td>
                                                    <td>{inputs.incidentType.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created At:</td>
                                                    <td>{inputs.createdAt ? formatDate(inputs.createdAt) : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created By:</td>
                                                    <td>{inputs.createdBy}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                    Incident Number
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="incidentNo"
                                                        required
                                                        value={inputs.incidentNo || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Date Of Incident
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="dateOfIncident"
                                                        required
                                                        value={inputs.dateOfIncident || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="timeOfIncident" className="font-weight-bold">
                                                    Time Of Incident
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="timeOfIncident"
                                                        required
                                                        value={inputs.timeOfIncident || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                  
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="categoryId" className="font-weight-bold">
                                                    Incident Type
                                                    </label>
                                                    <Select
                                                  name="incidentTypeId"
                                                value={incidentTypes.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.incidentTypeId
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={incidentTypes}
                                            />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="severityId" className="font-weight-bold">
                                                    Severity
                                                    </label>
                                                    <Select
                                                  name="severityId"
                                                value={severity.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.severityId
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={severity}
                                            />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="statusId" className="font-weight-bold">
                                                    likely Hood                                                   </label>
                                                    <Select
                                                  name="likelyHoodId"
                                                value={incidentLikelyhood.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.likelyHoodId
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={incidentLikelyhood}
                                            />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="countyId_" className="font-weight-bold">
                                                    County
                                                    </label>
                                                    <Select
                                                  name="countyId"
                                                value={counties.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.countyId
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={counties}
                                            />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="subCountyId_" className="font-weight-bold">
                                                        Subcounty
                                                    </label>
                                                    <Select
                                                  name="subCountyId"
                                                value={subcounties.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.subCountyId
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={subcounties}
                                            />
                                        </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="town" className="font-weight-bold">
                                                    Location Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="locationName"
                                                        required
                                                        value={inputs.locationName || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="nameOfOrganization" className="font-weight-bold">
                                                    Organization
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="nameOfOrganization"
                                                        required
                                                        value={inputs.nameOfOrganization || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayOpen" className="font-weight-bold">
                                                    Police Called To Scene
                                                    </label>
                                                    <Select
                                                  name="policeCalledToScene"
                                                value={policeCalledToSceneOptions.filter(
                                                (option) =>
                                                  option.value ===
                                                  inputs.policeCalledToScene
                                              )}
                                              onChange={
                                                handleSelectChange
                                              }
                                              options={policeCalledToSceneOptions}
                                            />
                                              </div>
                                            </div>                                      
                                        </div>
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={inputs.description || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>
                                                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                                <div className={`tab-pane fade ${activeTab === 'persons-involved' ? 'show active' : ''}`} id="persons-involved-tab-pane" role="tabpanel" aria-labelledby="persons-involved-tab">
                                <h3>Persons Involved</h3>
                                   {viewPersonInvloved ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewPersonInvloved(false)}}>Add person involved</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                    <th>Name</th>
                                                    <th>Nationality</th>
                                                    <th>telNo</th>
                                                    <th>email</th>
                                                    <th>transferredToHospital</th>
                                                    <th>refusedHospital</th>
                                                    <th>severityLevel</th>
                                                    <th>descriptionOfInjury</th>
                                                </tr>
                                            <tbody>
                                            

                                            {allpersonsInvolved.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                    <td>{d.name}</td>
                                                    <td>{d.nationality}</td>
                                                    <td>{d.telNo}</td>
                                                    <td>{d.email}</td>
                                                    <td>{d.transferredToHospital}</td>
                                                    <td>{d.refusedHospital}</td>
                                                    <td>{d.severityLevel.name}</td>
                                                    <td>{d.descriptionOfInjury}</td>
                                                </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmitPersonsInvloved}>
                                        <button className="btn-warning" onClick={()=>{setViewPersonInvloved(true)}}>Back</button>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="code" className="font-weight-bold">
                                                    Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={inputsPersonInvolved.name || ""}
                                                        onChange={handlePersonsInvolvedInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    nationality
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="nationality"
                                                        required
                                                        value={inputsPersonInvolved.nationality || ""}
                                                        onChange={handlePersonsInvolvedInputChange}
                                                    />
                                                </div>
                                            </div>
                                        
                                        </div>
                                  
                                        <div className="row">
                                     
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="categoryId" className="font-weight-bold">
                                                    Email
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        required
                                                        value={inputsPersonInvolved.email || ""}
                                                        onChange={handlePersonsInvolvedInputChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="timeOfIncident" className="font-weight-bold">
                                                    Telephone number
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="telNo"
                                                        required
                                                        value={inputsPersonInvolved.telNo || ""}
                                                        onChange={handlePersonsInvolvedInputChange}
                                                    />
                                                </div>
                                            </div>
 
                                        </div> 
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="severityId" className="font-weight-bold">
                                                    Severity
                                                    </label>
                                                    <Select
                                                  name="severityId"
                                                value={severity.filter(
                                                (option) =>
                                                  option.value ===
                                                inputsPersonInvolved.severityId
                                              )}
                                              onChange={
                                                handleSelectPersonInvolvedChange
                                              }
                                              options={severity}
                                            />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="weekDayOpen" className="font-weight-bold">
                                                    Transferred To Hospital
                                                    </label>
                                                    <Select
                                                  name="transferredToHospital"
                                                value={policeCalledToSceneOptions.filter(
                                                (option) =>
                                                  option.value ===
                                                inputsPersonInvolved.transferredToHospital
                                              )}
                                              onChange={
                                                handleSelectPersonInvolvedChange
                                              }
                                              options={policeCalledToSceneOptions}
                                            />
                                              </div>
                                            </div>  
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="nameOfOrganization" className="font-weight-bold">
                                                    Refused Hospital
                                                    </label>

                                                    <Select
                                                  name="refusedHospital"
                                                value={policeCalledToSceneOptions.filter(
                                                (option) =>
                                                  option.value ===
                                                inputsPersonInvolved.refusedHospital
                                              )}
                                              onChange={
                                                handleSelectPersonInvolvedChange
                                              }
                                              options={policeCalledToSceneOptions}
                                            /> 
                                                </div>
                                            </div>                                    
                                        </div>
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description of injury
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="descriptionOfInjury"
                                                        required
                                                        value={inputsPersonInvolved.descriptionOfInjury || ""}
                                                        onChange={handlePersonsInvolvedInputChange}
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>
                                                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                                <div className={`tab-pane fade ${activeTab === 'actions-taken' ? 'show active' : ''}`} id="actions-taken-tab-pane" role="tabpanel" aria-labelledby="actions-taken-tab">
                                <h3>Action taken</h3>
                                   {viewActiontaken ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewActiontaken(false)}}>Add Action taken</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                    <th>By</th>
                                                    <th>Action </th>
                                                    
                                                </tr>
                                            <tbody>
                                            

                                            {allActiontaken.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                     <td>{d.actionTakenBy}</td>
                                                    <td>{d.actionTaken}</td>
                                                   </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmitActionTaken}>
                                        <button className="btn-warning" onClick={()=>{setViewActiontaken(true)}}>Back</button>
                                        <div className="row"> 
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Action Taken By
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="actionTakenBy"
                                                        required
                                                        value={inputsActionTaken.actionTakenBy || ""}
                                                        onChange={handleActionTakenInputChange}
                                                    />
                                                </div>
                                            </div>
                                        
                                        </div>
                                  
                                       
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Action Taken
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="actionTaken"
                                                        required
                                                        value={inputsActionTaken.actionTaken || ""}
                                                        onChange={handleActionTakenInputChange}
                                                    />
                                                </div>
                                            </div>
                                    
                                        </div>
                                                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                                <div className={`tab-pane fade ${activeTab === 'Documents' ? 'show active' : ''}`} id="Documents-tab-pane" role="tabpanel" aria-labelledby="Documents-tab">
                                <h3>Documents</h3>
                                   {viewDocuments ? (
                                    <div>
                                        <button className="btn-primary" onClick={()=>{setViewDocuments(false)}}>Add Document</button>
                                        <br/>
                                            <table className="table table-sm">
                                                <tr>
                                                <th>id</th>
                                                <th>Type</th>
                                                    <th>Name</th>
                                                    <th>Description </th>
                                                    <th>View </th>
                                                </tr>
                                            <tbody>
                                            

                                            {allDocuments.map(d => ( 
                                                <tr key={d.id}>
                                                     <td>{d.id}</td>
                                                     <td>{d.docType.name}</td>
                                                     <td>{d.name}</td>
                                                    <td>{d.description}</td>
                                                    <td><a href={ process.env.REACT_APP_BASE_URL +"api/upload/files/"+d.path} target="_blank"> View </a></td>
                                                   </tr>
                                               ))} 
                                                
                                                 
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmitDocuments}>
                                        <button className="btn-warning" onClick={()=>{setViewDocuments(true)}}>Back</button>
                                        <div className="row"> 
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Document Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={documents.name || ""}
                                                        onChange={handleDocumentsInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                    Document Type
                                                    </label>
                                                    <Select
                                                  name="typeId"
                                                value={documentTypes.filter(
                                                (option) =>
                                                  option.value ===
                                                documents.typeId
                                              )}
                                              onChange={
                                                handleSelectDocumentsChange
                                              }
                                              options={documentTypes}
                                            />
                                                </div>
                                            </div>
                                        </div>
                                  
                                       
                                        <div className="row">
                                        <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                    Description
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={documents.description || ""}
                                                        onChange={handleDocumentsInputChange}
                                                    />
                                                </div>
                                            </div>                                    
                                        </div>
                                        <div className="row">
                                        <div className="col-sm-12">
                                            <input
                                                type="file"
                                                className="form-control"
                                                name="file"
                                                onChange={onChangeHandler}
                                                accept=".xlsx, .xls, .csv"
                                            />
                                            </div>
                                            <br/>
                                            <div className="col-sm-12">
                                                <Progress
                                                max="100"
                                                color="success"
                                                value={loaded}
                                                >
                                                {Math.round(loaded, 2)}%
                                                </Progress>
                                                <button
                                                type="button"
                                                class="btn btn-success "
                                                onClick={onClickHandler}
                                                >
                                                Upload
                                                </button>
                                            </div>
                                            <p>{message}</p>
                                        </div>
                                          <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                                </div>
                            </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SecurityIncident;
